/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Acted Core API
 * Core backend API.
 * OpenAPI spec version: 1.0.0
 */
import {
  HttpClient
} from '@angular/common/http';
import type {
  HttpContext,
  HttpEvent,
  HttpParams
} from '@angular/common/http';

import type {
  HttpHeaders,
  HttpResponse as AngularHttpResponse
} from '@angular/common/http';

import {
  Injectable,
  inject
} from '@angular/core';

import type {
  Observable
} from 'rxjs';

import type {
  Attachment,
  AttachmentCreateRequestRequest,
  LongRunningJob,
  LongRunningJobsAttachmentsListParams,
  LongRunningJobsListParams,
  PaginatedAttachmentList,
  PaginatedLongRunningJobList
} from '../model';

import {
  environment
} from 'environments/environment';



import { filterParams, HttpClientBodyOptions, HttpClientEventOptions, HttpClientObserveOptions, HttpClientResponseOptions } from '../httpClientOptions';

@Injectable({ providedIn: 'root' })
export class LongRunningJobsService {
  private readonly http = inject(HttpClient);
 list<TData = PaginatedLongRunningJobList>(params?: LongRunningJobsListParams, options?: HttpClientBodyOptions): Observable<TData>;
 list<TData = PaginatedLongRunningJobList>(params?: LongRunningJobsListParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 list<TData = PaginatedLongRunningJobList>(params?: LongRunningJobsListParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  list<TData = PaginatedLongRunningJobList>(
    params?: LongRunningJobsListParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `${environment.apiRoot}/api/long-running-jobs/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `${environment.apiRoot}/api/long-running-jobs/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `${environment.apiRoot}/api/long-running-jobs/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }
 retrieve<TData = LongRunningJob>(code: string, options?: HttpClientBodyOptions): Observable<TData>;
 retrieve<TData = LongRunningJob>(code: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 retrieve<TData = LongRunningJob>(code: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  retrieve<TData = LongRunningJob>(
    code: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `${environment.apiRoot}/api/long-running-jobs/${code}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `${environment.apiRoot}/api/long-running-jobs/${code}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `${environment.apiRoot}/api/long-running-jobs/${code}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * List all attachments on the current instance, supporting filters, sorting and pagination
 */
 attachmentsList<TData = PaginatedAttachmentList>(code: string,
    params?: LongRunningJobsAttachmentsListParams, options?: HttpClientBodyOptions): Observable<TData>;
 attachmentsList<TData = PaginatedAttachmentList>(code: string,
    params?: LongRunningJobsAttachmentsListParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 attachmentsList<TData = PaginatedAttachmentList>(code: string,
    params?: LongRunningJobsAttachmentsListParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  attachmentsList<TData = PaginatedAttachmentList>(
    code: string,
    params?: LongRunningJobsAttachmentsListParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `${environment.apiRoot}/api/long-running-jobs/${code}/attachments/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `${environment.apiRoot}/api/long-running-jobs/${code}/attachments/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `${environment.apiRoot}/api/long-running-jobs/${code}/attachments/`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }
/**
 * Create attachments for the current instance via an HTTP POST
 */
 attachmentsCreate<TData = Attachment[]>(code: string,
    attachmentCreateRequestRequest: AttachmentCreateRequestRequest, options?: HttpClientBodyOptions): Observable<TData>;
 attachmentsCreate<TData = Attachment[]>(code: string,
    attachmentCreateRequestRequest: AttachmentCreateRequestRequest, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 attachmentsCreate<TData = Attachment[]>(code: string,
    attachmentCreateRequestRequest: AttachmentCreateRequestRequest, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  attachmentsCreate<TData = Attachment[]>(
    code: string,
    attachmentCreateRequestRequest: AttachmentCreateRequestRequest, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {const formData = new FormData();
if(attachmentCreateRequestRequest.description !== undefined) {
 formData.append(`description`, attachmentCreateRequestRequest.description);
 }
if(attachmentCreateRequestRequest.detail !== undefined) {
 formData.append(`detail`, attachmentCreateRequestRequest.detail);
 }
attachmentCreateRequestRequest.theFile.forEach(value => formData.append(`theFile`, value));
if(attachmentCreateRequestRequest.type !== undefined) {
 formData.append(`type`, attachmentCreateRequestRequest.type);
 }

    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `${environment.apiRoot}/api/long-running-jobs/${code}/attachments/`,
      formData,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `${environment.apiRoot}/api/long-running-jobs/${code}/attachments/`,
      formData,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.post<TData>(
      `${environment.apiRoot}/api/long-running-jobs/${code}/attachments/`,
      formData,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Delete a specific attachment on this instance
 */
 attachmentsDestroy<TData = void>(code: string,
    attachmentUuid: string, options?: HttpClientBodyOptions): Observable<TData>;
 attachmentsDestroy<TData = void>(code: string,
    attachmentUuid: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 attachmentsDestroy<TData = void>(code: string,
    attachmentUuid: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  attachmentsDestroy<TData = void>(
    code: string,
    attachmentUuid: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.delete<TData>(
      `${environment.apiRoot}/api/long-running-jobs/${code}/attachments/${attachmentUuid}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(
      `${environment.apiRoot}/api/long-running-jobs/${code}/attachments/${attachmentUuid}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.delete<TData>(
      `${environment.apiRoot}/api/long-running-jobs/${code}/attachments/${attachmentUuid}/`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
/**
 * Download a specific attachment on this instance
 */
 attachmentsDownload(code: string,
    attachmentUuid: string, options?: HttpClientBodyOptions): Observable<Blob>;
 attachmentsDownload(code: string,
    attachmentUuid: string, options?: HttpClientEventOptions): Observable<HttpEvent<Blob>>;
 attachmentsDownload(code: string,
    attachmentUuid: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<Blob>>;
  attachmentsDownload(
    code: string,
    attachmentUuid: string, options?: HttpClientObserveOptions): Observable<Blob | HttpEvent<Blob> | AngularHttpResponse<Blob>> {
    if (options?.observe === 'events') {
      return this.http.get(
      `${environment.apiRoot}/api/long-running-jobs/${code}/attachments/${attachmentUuid}/download/`,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',}
    ) as Observable<HttpEvent<Blob>>;
    }

    if (options?.observe === 'response') {
      return this.http.get(
      `${environment.apiRoot}/api/long-running-jobs/${code}/attachments/${attachmentUuid}/download/`,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',}
    ) as Observable<AngularHttpResponse<Blob>>;
    }

    return this.http.get(
      `${environment.apiRoot}/api/long-running-jobs/${code}/attachments/${attachmentUuid}/download/`,{
        responseType: 'blob',
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',}
    ) as Observable<Blob>;
  }
};

